
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component
export default class SmallBadge extends Vue {
  @Prop({ default: 'example' })
  private value: string;
  @Prop({ default: '#76b6a1' })
  private bgColor: string;

  constructor() {
    super();
  }
}
